import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const InvitedIcon = ({ fill = 'white', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox={'0 0 14 14'}>
            <g fill="none" fillRule="evenodd">
                <circle className={fillStyles} stroke="#9DB2C4" cx={7} cy={7} r={6.5} />
                <path
                    d="M7.681 8.011a.636.636 0 0 1-.635.605.64.64 0 0 1-.638-.605l-.242-4.476a.864.864 0 0 1 .904-.909c.48.023.85.43.826.91L7.681 8.01zM7 9.958c.499 0 .875.376.875.875a.86.86 0 0 1-.875.875.866.866 0 0 1-.875-.875A.86.86 0 0 1 7 9.958z"
                    fill="#9DB2C4"
                />
            </g>
        </svg>
    );
};
